import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import TitleField from '../../fields/TitleField';
import FlagsField from '../../fields/FlagsField';
import DescriptionField from '../../fields/DescriptionField';
import PriceField from '../../fields/PriceField';
import TagsField from '../../fields/TagsField';
import DisplayOptionsField from '../../fields/DisplayOptionsField';
import ProgressIsVisibleField from '../../fields/ProgressIsVisibleField';
import OpenForOrdersField from '../../fields/OpenForOrdersField';

import s from './FirstStep.scss';

interface Props {
  deviation?: PapiDeviation;
}

const FirstStep: React.FC<Props> = ({ deviation }) => {
  const showDisplayOptions = deviation && !deviation.isDefaultImage;
  const showOpenForOrders = deviation && !deviation.isDefaultImage && deviation.isPublished;
  return (
    <div className={s['root']}>
      {showOpenForOrders && <OpenForOrdersField />}
      <div data-field="title">
        <TitleField />
      </div>
      <FlagsField />
      <div data-field="description">
        <DescriptionField />
      </div>
      <div data-field="price">
        <PriceField />
      </div>
      <ProgressIsVisibleField />
      <TagsField noBottomSpacing={showDisplayOptions} />
      {showDisplayOptions && <DisplayOptionsField deviation={deviation} />}
    </div>
  );
};
FirstStep.displayName = 'FirstStep';

export default FirstStep;
